










import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  name: 'Error404'
})
